/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Tier_1_NInputs */

const en_cp_tier_1_n = /** @type {(inputs: Cp_Tier_1_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perintis`)
};

const id_cp_tier_1_n = /** @type {(inputs: Cp_Tier_1_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perintis`)
};

/**
* | output |
* | --- |
* | "Perintis" |
*
* @param {Cp_Tier_1_NInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_tier_1_n = /** @type {((inputs?: Cp_Tier_1_NInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Tier_1_NInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_tier_1_n(inputs)
	return en_cp_tier_1_n(inputs)
});